export enum Languages {
  PL = 'pl',
  EN = 'en',
}
